__webpack_require__.p = "/gnoccata/";